var React = require('react');

function Point (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.46061 4.481C2.07528 4.481 1.71828 4.38467 1.38961 4.192C1.07228 3.99933 0.817276 3.74433 0.624609 3.427C0.443276 3.09833 0.352609 2.73567 0.352609 2.339C0.352609 1.931 0.443276 1.56833 0.624609 1.251C0.817276 0.922333 1.07228 0.661666 1.38961 0.469C1.71828 0.276333 2.07528 0.18 2.46061 0.18C2.86861 0.18 3.23128 0.276333 3.54861 0.469C3.87728 0.661666 4.13794 0.922333 4.33061 1.251C4.52328 1.56833 4.61961 1.931 4.61961 2.339C4.61961 2.73567 4.52328 3.09833 4.33061 3.427C4.13794 3.74433 3.87728 3.99933 3.54861 4.192C3.23128 4.38467 2.86861 4.481 2.46061 4.481Z","fill":"#00140F"}));
}

Point.defaultProps = {"width":"5","height":"5","viewBox":"0 0 5 5","fill":"none"};

module.exports = Point;

Point.default = Point;
